// extracted by mini-css-extract-plugin
export var arrow = "_dm-1";
export var content = "_dm-0";
export var highlighted = "_dm-2";